import React from 'react'
import Loadable from 'react-loadable'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import isStorageAvailable from 'utils/isStorageAvailable'

const Magic = Loadable({ loader: () => import('./Magic'), loading: () => null })

export class MagicAwakener extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      magic: false,
    }
  }

  componentDidMount() {
    if (!isStorageAvailable('sessionStorage')) {
      return
    }

    if (this.props.location.search.includes('magic=sant')) {
      this.props.history.replace({
        ...this.props.location,
        search: this.props.location.search.replace('magic=sant', ''),
      })

      window.sessionStorage.setItem('magic', true)
    }

    if (JSON.parse(window.sessionStorage.getItem('magic')) === true) {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        magic: true,
      })
    }
  }

  render() {
    if (this.state.magic) {
      return <Magic />
    }

    return null
  }
}

MagicAwakener.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
}

export default withRouter(MagicAwakener)
